export const CONTENT_LANGS = ['es', 'en', 'pt'] as const

export const langLabels: Record<string, string> = {
  es: 'Español',
  en: 'Inglés',
  pt: 'Portugués',
}

export const archetypeLabels: Record<string, string> = {
  codes: 'Códigos',
}

export const sourceLabels: Record<string, string> = {
  extracted: 'Extraída del artículo',
  manual: 'Editada a mano (congelada)',
}

/** El texto de una opción: los códigos son iguales en los tres idiomas. */
export const optionText = (option: { code?: string | null, label?: any }, lang = 'es') => {
  if (option.code) return option.code
  if (typeof option.label === 'string') return option.label

  return option.label?.[lang] || option.label?.es || '—'
}
